import { useTranslation } from "react-i18next";
import { useTheme } from "src/lib/context/theme-context";
import "./styles.css";

export const InfoSectionWithSteps = ({ steps, title }) => {
  const { t } = useTranslation(["module1", "module2", "module3", "module4"]);
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const theme = useTheme();

  return (
    <section className="info-section-with-steps">
      <div className="flex flex-col">
        <p className="font-lg info-section-title">{t(title)}</p>
        <div className="steps-container">
          {steps?.map((s) => (
            <div key={s.title} className="info-item">
              <img
                src={theme === "dark" && s.darkImage ? s.darkImage : s.image}
                alt={t(s.title)}
                className="info-item-image"
                aria-hidden="true"
              />
              <div className="info-item-content">
                <div
                  role="text"
                  className="info-item-title"
                  aria-label={
                    lang === "tr"
                      ? t(s.title).toLowerCase().replaceAll("qr", "küar")
                      : t(s.title).toLowerCase().replaceAll("Martı", "marti")
                  }
                >
                  {t(s.title)}
                </div>
                <div
                  role="text"
                  className="info-item-description"
                  aria-label={
                    lang === "tr"
                      ? t(s.description).toLowerCase().replaceAll("qr", "küar")
                      : t(s.description).toLowerCase().replaceAll("Martı", "marti")
                  }
                >
                  {t(s.description)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
